import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
import { useSearchParams } from "react-router-dom";
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import LoginTop from "../common/LoginTop";
import LoginBottom from "../common/LoginBottom";
import EmailLogin from "./EmailLogin";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
//
import IconEmail from "../../../../../images/icon_email_active/icon_email_active.svg";
import FirebaseAuthLogin from "../common/FirebaseAuthLogin";

// style

const StyledBoxDividerSplit = styled(
  Box,
  {}
)(({ theme }) => ({
  width: "126px",
  height: "0.5px",
  backgroundColor: "#505050",
}));

const StyledLinkDark = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#121212",
  cursor: "pointer",
}));

const StyledLinkBlue = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#3bbff0",
  cursor: "pointer",
}));

const CustomLoginUI = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();

  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const handleGoSignup = () => {
    navigate(handleLocaleRoute(ROUTE_PATH.Signup));
  };

  return (
    <Box
      width="400px"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box width="300px" mb={6}>
        <LoginTop />

        {/* firebase login */}
        <Box>
          <FirebaseAuthLogin />
        </Box>

        <Box display="flex" mb={4} alignItems="center" justifyContent="center">
          <StyledBoxDividerSplit />
          <Box mx={2}>
            <Typography>
              {intl.formatMessage({
                id: "login.singin.or",
                defaultMessage: "或",
              })}
            </Typography>
          </Box>
          <StyledBoxDividerSplit />
        </Box>

        {/* email login */}
        <EmailLogin />

        <Box>
          <Typography textAlign="center">
            <span>
              {intl.formatMessage({
                id: "login.notyet.singup.question",
                defaultMessage: "還沒加入嗎？ ",
              })}
            </span>
            <StyledLinkBlue onClick={handleGoSignup}>
              {intl.formatMessage({
                id: "login.notyet.singup.go",
                defaultMessage: "註冊",
              })}
            </StyledLinkBlue>
          </Typography>
        </Box>
      </Box>

      <Box width="400px">
        <LoginBottom />
      </Box>
    </Box>
  );
};

CustomLoginUI.propTypes = {};

CustomLoginUI.defaultProps = {};

export default CustomLoginUI;
